module.exports = __webpack_public_path__ + "static/media/orange_small.10af2f12.svg";